import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationStart, Router, RouterEvent, RoutesRecognized } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import * as fromStore from '@core/store';
import { StyleManagerService } from '@core/shared/services/style-manager.service';
import * as fromThemeAction from '@core/store/actions/theme.action';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService} from '@core/shared/services/http.service';

export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  isAuthenticated: boolean;
  userId: string;
  title;
  routeData: any;
  // isFullView: boolean;
  theme: string;
  radius: string;
  @Input() isFullView: boolean;
  private onDestroy$ = new Subject<void>();
  navigationStartSubscription: Subscription;
  public destroyed = new Subject<any>();

  constructor(private router: Router, private store: Store<fromStore.PlatformState>, private translateService: TranslateService,
    private titleService: Title, private themeService: StyleManagerService, private http: HttpService) {

    this.store.select(fromStore.themeState).pipe(takeUntil(this.onDestroy$)).subscribe(state => {
      this.isFullView = state.isExpand;
      this.theme = state.theme;
      this.radius = state.radius;
      this.changeTheme();
      this.changeRadius();
    });

    this.store.select(fromStore.authenticationState).pipe(takeUntil(this.onDestroy$)).subscribe(state => {
      this.isAuthenticated = state.status;
      if (state.user)
        this.userId = state.user.Id;
    });

    this.navigationStartSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
    });
  }

  ngOnInit(): void {
    // debugger;
    this.router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        this.routeData = data.state.root.firstChild.data;
        if (this.routeData && this.routeData.title) {
          this.translateService.get(this.routeData.title).subscribe((res: string) => {
            this.title = res;
            this.titleService.setTitle(res);
          });
        }
      }
    });
  }

  getProgramName(username){
    var domain = window.location.host;
     // var domain = 'threemacqa.channelsmart.net';
    return this.http.get(`participant/getUserProgramName?url=${domain}&userName=${username}`).pipe(map((response: any) => {
      return response;
  }));
  }

  changeTheme() {
    // debugger;
    if (localStorage.getItem("token")){
      if (sessionStorage.getItem("programName") == null || sessionStorage.getItem("programName") == '') {
        var username = JSON.parse(localStorage.getItem('token'))['access_token'];
        this.getProgramName(username).subscribe((data: any) =>{
          var theme = data.participantProgramDetails.programName.toLowerCase();
          sessionStorage.setItem("programName",theme);
          this.themeService.setStyle("theme", `assets/themes/custom/${theme}.css`);
        });
      }else{
        var theme = sessionStorage.getItem("programName");
        this.themeService.setStyle("theme", `assets/themes/custom/${theme}.css`); 
      } 
    }else{
      this.getProgramName('').subscribe((data: any) =>{
        var theme = (data.participantProgramDetails.programName)? data.participantProgramDetails.programName.toLowerCase():'';
        sessionStorage.setItem("programName",theme);
        this.themeService.setStyle("theme", `assets/themes/custom/${theme}.css`);
      });
    }
  }

  changeRadius() {
    this.themeService.setStyle("radius", `assets/radius/${this.radius}.css`);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    if (this.navigationStartSubscription)
      this.navigationStartSubscription.unsubscribe();
  }

  toggleView() {
    this.store.dispatch({ type: fromThemeAction.TOGGLE_PANEL, payload: !this.isFullView });
  }

}
